import { render, staticRenderFns } from "./index.vue?vue&type=template&id=068fa654&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=068fa654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068fa654",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeRowItem: require('/Users/leo/Desktop/pc/zgszcy/components/homeRowItem/index.vue').default})
